module.exports = __webpack_public_path__ + "media/overlays/02-351bd682.png";